import React, { FunctionComponent, useEffect, useState } from 'react';
import { useModalToggle } from '../../hooks/useModalToggle';
import EncourageShareModal from './EncourageShareModal';
import useAbEnrol from '../../hooks/useAbEnrol';

const EncourageShareModalContainer: FunctionComponent = () => {
  const { setOpen, isOpen, ref, Portal } = useModalToggle();
  const storageKey = 'isEncourageSharePromptDismissed';
  const closeModal = () => {
    localStorage.setItem(storageKey, String(true));
    setOpen(false);
  };
  const { enrolledInVariation } = useAbEnrol(
    'fr_growth_encourage_share_time_30_seconds',
  );
  const [isEnrolledIn30SecondsModal, setIsEnrolledIn30SecondsModal] = useState(
    false,
  );

  useEffect(() => {
    const userHasDismissed = localStorage.getItem(storageKey) === String(true);

    if (userHasDismissed) {
      return;
    }

    if (enrolledInVariation) {
      const isEnrolledInB = enrolledInVariation === 'B';
      setIsEnrolledIn30SecondsModal(isEnrolledInB);
      const timeoutInMs = isEnrolledInB ? 30000 : 40000;

      const timer = global.setTimeout(() => {
        setOpen(true);
      }, timeoutInMs);

      return () => clearTimeout(timer);
    }
  }, [setOpen, enrolledInVariation]);

  return (
    <>
      {isOpen && (
        <Portal background focusLock scrollLock onClose={closeModal}>
          <EncourageShareModal
            isEnrolledIn30SecondsModal={isEnrolledIn30SecondsModal}
            ref={ref}
            onClose={closeModal}
          />
        </Portal>
      )}
    </>
  );
};

export default EncourageShareModalContainer;
